// Soft scroll wall for the reels feed: each viewer gets a daily allowance of
// unblurred reels (anonymous < registered). Reels already counted today stay
// unlocked; anything past the allowance renders blurred behind a prompt.
export const ANON_FREE_REELS = 10;
export const REGISTERED_FREE_REELS = 25;

const STORAGE_PREFIX = 'gb.reelsSeen.';

export function reelCap(user) {
  return user ? REGISTERED_FREE_REELS : ANON_FREE_REELS;
}

export function todayKey(now = new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function storageKey(user) {
  return `${STORAGE_PREFIX}${user?.id ?? 'anon'}`;
}

export function loadSeen(user, now = new Date()) {
  try {
    const raw = window.localStorage.getItem(storageKey(user));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (parsed?.day !== todayKey(now) || !Array.isArray(parsed.ids)) return [];
    return parsed.ids.map(String);
  } catch {
    return [];
  }
}

export function saveSeen(user, ids, now = new Date()) {
  try {
    window.localStorage.setItem(storageKey(user), JSON.stringify({ day: todayKey(now), ids: ids.map(String) }));
  } catch {}
}

export function isReelLocked(promoId, seenIds, cap) {
  const id = String(promoId);
  if (seenIds.includes(id)) return false;
  return seenIds.length >= cap;
}
